import { render, staticRenderFns } from "./fieldCollection.vue?vue&type=template&id=7371e728&scoped=true&"
import script from "./fieldCollection.vue?vue&type=script&lang=js&"
export * from "./fieldCollection.vue?vue&type=script&lang=js&"
import style0 from "./fieldCollection.vue?vue&type=style&index=0&id=7371e728&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7371e728",
  null
  
)

export default component.exports